import api from "../utils/api";
import { isGuid } from "../utils/string";
import {
  LOGOUT
} from "./types";

export const save = ({
    uuid,
    number,
    title,
    hireDate,
    termDate,
    status,
    payType,
    payRate,
    locationUuid,
    payScheduleUuid,
    rateCode,
    meta,
    roles,
}) => async (dispatch) => {
    try {
        const res = await api.post(`/staff`, {
            uuid,
            number,
            title,
            hireDate,
            termDate,
            status,
            payType,
            payRate,
            locationUuid,
            payScheduleUuid,
            rateCode,
            meta,
            roles,
        });
        return res.data;
    } catch (error) {
        if (error?.response?.status === 401) {
            dispatch({
                type: LOGOUT
            });
        }
        throw error;
    }
};

export const destroy = ({ uuid }) => async (dispatch) => {
    try {
        const res = isGuid(uuid) ? await api.delete(`/staff/i/${uuid}`) : { data: { success: false } };
        return res.data;
    } catch (err) {
        if (err?.response?.status === 401) {
            dispatch({
                type: LOGOUT
            });
        }
        throw err;
    }
};

export const get = ({ uuid }) => async (dispatch) => {
    try {
        const res = isGuid(uuid) ? await api.get(`/staff/i/${uuid}`) : await api.get("/staff");
        return isGuid(uuid) ? res.data.items[0] : res.data.items;
    } catch (err) {
        if (err?.response?.status === 401) {
            dispatch({
                type: LOGOUT
            });
        }
        throw err;
    }
};

export const billable = ({ uuid, caseUuid, personUuid }) => async (dispatch) => {
    try {
        const res = isGuid(uuid)
            ? await api.get(`/cases/staff/billable/s/${uuid}/c/${caseUuid ?? "x"}/p/${personUuid ?? "x"}`)
            : { data: { success: false } };
        return res.data;
    } catch (err) {
        if (err?.response?.status === 401) {
            dispatch({
                type: LOGOUT
            });
        }
        throw err;
    }
};

export const tax = ({ state, filing, deduction, credit, extra, multipleJobs }) => async (dispatch) => {
    try {
        const res = await api.post("/staff/me", { state, filing, deduction, credit, extra, multipleJobs });
        return res.data;
    } catch (err) {
        if (err?.response?.status === 401) {
            dispatch({
                type: LOGOUT
            });
        }
        throw err;
    }
};

export const me = () => async (dispatch) => {
    try {
        const res = await api.get("/staff/me");
        return res.data;
    } catch (err) {
        if (err?.response?.status === 401) {
            dispatch({
                type: LOGOUT
            });
        }
        throw err;
    }
};

export const getAccountingLedger = () => async (dispatch) => {
    try {
        const res = await api.get("/staff/me/accounting-ledger");
        return res.data;
    } catch (err) {
        if (err?.response?.status === 401) {
            dispatch({
                type: LOGOUT
            });
        }
        throw err;
    }
};

export const saveAccountingLedger = ({ accountUuids = [] } = {}) => async (dispatch) => {
    try {
        const res = await api.put("/staff/me/accounting-ledger", { accountUuids });
        return res.data;
    } catch (err) {
        if (err?.response?.status === 401) {
            dispatch({
                type: LOGOUT
            });
        }
        throw err;
    }
};
